import { SxProps, Theme } from '@mui/material';

export const flashbookCardStyle: SxProps<Theme> = {
  border: '1px solid',
  borderColor: 'darkerLightGrey.main',
  borderRadius: 2.5,
  overflow: 'hidden',
  bgcolor: 'common.white',
};

export const formSectionStyle: SxProps<Theme> = {
  py: 3,
  '&:first-of-type': { pt: 0 },
  borderBottom: '1px solid',
  borderColor: 'darkerLightGrey.main',
};

export const formSectionLastStyle: SxProps<Theme> = {
  py: 3,
  '&:first-of-type': { pt: 0 },
};

export const sizeTableShellStyle: SxProps<Theme> = {
  border: '1px solid',
  borderColor: 'darkerLightGrey.main',
  borderRadius: 2,
  overflow: 'hidden',
};

export const SIZE_TABLE_COLUMNS = '28px 1fr 110px 120px';

export const sizeTableHeaderStyle: SxProps<Theme> = {
  px: 2,
  py: 1.5,
  borderBottom: '1px solid',
  borderColor: 'darkerLightGrey.main',
  bgcolor: 'lightGrey.main',
};

export const sizeTableRowStyle: SxProps<Theme> = {
  px: 2,
  py: 1.5,
  borderBottom: '1px solid',
  borderColor: 'darkerLightGrey.main',
};

export const sizeTableRowLastStyle: SxProps<Theme> = {
  px: 2,
  py: 1.5,
};

export const detailRowStyle: SxProps<Theme> = {
  px: 2.5,
  py: 2,
  borderBottom: '1px solid',
  borderColor: 'darkerLightGrey.main',
};

export const detailRowLastStyle: SxProps<Theme> = {
  px: 2.5,
  py: 2,
};

export const detailRowIconStyle: SxProps<Theme> = {
  flex: '0 0 28px',
  width: 28,
  height: 28,
  color: 'common.black',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const previewRowStyle: SxProps<Theme> = {
  py: 1,
  typography: 'body2',
  borderBottom: '1px solid',
  borderColor: 'darkerLightGrey.main',
  '&:last-of-type': { borderBottom: 0 },
};

export const tagChipStyle: SxProps<Theme> = {
  bgcolor: 'accent.main',
  color: 'secondary.main',
  typography: 'caption',
  fontWeight: 600,
  borderRadius: 999,
};

export const tagChipInputStyle: SxProps<Theme> = {
  ...tagChipStyle,
  pl: 0.5,
  '& .MuiChip-deleteIcon': {
    color: 'secondary.main',
    bgcolor: 'transparent',
    margin: 0,
    marginRight: '6px',
    '&:hover': { color: 'secondary.dark' },
  },
};

export const tagInputFieldStyle: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    height: 'auto',
    minHeight: '44px',
    padding: '5px 12px',
    gap: 0.75,
    bgcolor: 'background.default',
    fontSize: 'body2.fontSize',
  },
  '& .MuiOutlinedInput-input': {
    fontSize: 'body2.fontSize',
    padding: '4px 4px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderWidth: '0.5px',
    borderColor: 'lightOutlineGrey.main',
  },
};

export const uploadPillStyle: SxProps<Theme> = {
  display: 'inline-flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 1,
  bgcolor: 'primary.light',
  color: 'primary.main',
  borderRadius: 999,
  py: 1.25,
  px: 2,
  typography: 'h5',
};

export const cardActionIconButtonStyle: SxProps<Theme> = {
  width: 32,
  height: 32,
  bgcolor: 'rgba(255,255,255,0.95)',
  border: '1px solid',
  borderColor: 'darkerLightGrey.main',
  transition: 'background-color 0.12s, border-color 0.12s',
  '&:hover': {
    bgcolor: 'common.white',
    borderColor: 'medGrey.main',
  },
};
